import { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { getDatosCliente } from "../../../../service/AffariService";
import LoaderTransparent from '../../../../components/ui/LoaderTransparent';



const DatosDialog = ({ visible, onCancel, codigo }) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (visible && codigo) {
            setLoading(true);
            setData(null);
            getDatosCliente(codigo)
                .then(setData)
                .catch((error) => {
                    console.error("Error fetching data:", error);
                })
                .finally(() => setLoading(false));
        }
    }, [visible, codigo]);

    const formatCurrency = (value) => {
        if (value === null || value === undefined) return;
        return new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP' }).format(value);
    };

    return (
        <Dialog
            header="Ficha del Cliente"
            visible={visible}
            className="p-fluid custom-dialog"
            modal
            onHide={onCancel}
            dismissableMask={true}
            draggable={false}
        >
            <div className="flex flex-column h-full">
                <div>
                    {loading && (
                        <div className="flex flex-column justify-content-center align-items-center py-6">
                            <LoaderTransparent coverParent overlayTint="transparent" />
                        </div>
                    )}
                    {data && (
                        <div className="flex flex-column gap-4">
                            {/* Sección Identificación */}
                            <div className="surface-card p-3 border-round-xl shadow-1">
                                <div className="text-500 font-medium text-sm mb-3 uppercase tracking-wide">Identificación</div>
                                <div className="grid grid-nogutter gap-3">
                                    <div className="col-12 flex align-items-center gap-3">
                                        <div className="w-2rem h-2rem border-circle surface-100 flex align-items-center justify-content-center text-primary">
                                            <i className="pi pi-hashtag text-sm"></i>
                                        </div>
                                        <div className="flex-1">
                                            <div className="text-500 text-xs mb-1">Código</div>
                                            <div className="text-900 font-medium">{data.cliente?.codigo || '—'}</div>
                                        </div>
                                    </div>
                                    <div className="col-12 flex align-items-center gap-3">
                                        <div className="w-2rem h-2rem border-circle surface-100 flex align-items-center justify-content-center text-primary">
                                            <i className="pi pi-briefcase text-sm"></i>
                                        </div>
                                        <div className="flex-1">
                                            <div className="text-500 text-xs mb-1">RUT</div>
                                            <div className="text-900 font-medium">{data.cliente?.rut || '—'}</div>
                                        </div>
                                    </div>
                                    <div className="col-12 flex align-items-center gap-3">
                                        <div className="w-2rem h-2rem border-circle surface-100 flex align-items-center justify-content-center text-primary">
                                            <i className="pi pi-building text-sm"></i>
                                        </div>
                                        <div className="flex-1">
                                            <div className="text-500 text-xs mb-1">Razón Social</div>
                                            <div className="text-900 font-medium">{data.cliente?.razonSocial || '—'}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Sección Financiera */}
                            <div className="surface-card p-3 border-round-xl shadow-1">
                                <div className="text-500 font-medium text-sm mb-3 uppercase tracking-wide">Información Financiera</div>
                                <div className="grid grid-nogutter gap-3">
                                    <div className="col-12 flex align-items-center gap-3">
                                        <div className={`w-2rem h-2rem border-circle flex align-items-center justify-content-center ${data.dato?.estado === 'ACTIVO' ? 'bg-green-100 text-green-600' : 'bg-orange-100 text-orange-600'}`}>
                                            <i className={`pi ${data.dato?.estado === 'ACTIVO' ? 'pi-check-circle' : 'pi-exclamation-circle'} text-sm`}></i>
                                        </div>
                                        <div className="flex-1">
                                            <div className="text-500 text-xs mb-1">Estado</div>
                                            <span className={`font-bold ${data.dato?.estado === 'ACTIVO' ? 'text-green-600' : 'text-orange-600'}`}>
                                                {data.dato?.estado || '—'}
                                            </span>
                                        </div>
                                    </div>
                                    
                                    <div className="col-12 grid grid-nogutter mt-2 pt-3 border-top-1 surface-border">
                                        <div className="col-6 mb-3 px-2">
                                            <div className="text-500 text-xs mb-1">Línea de Crédito</div>
                                            <div className="text-900 font-medium text-lg">{formatCurrency(data.dato?.credito) || '—'}</div>
                                        </div>
                                        <div className="col-6 mb-3 px-2">
                                            <div className="text-500 text-xs mb-1">Saldo Factura</div>
                                            <div className="text-900 font-medium text-lg">{formatCurrency(data.dato?.saldoFactura) || '—'}</div>
                                        </div>
                                        <div className="col-12 px-2">
                                            <div className="text-500 text-xs mb-1">Saldo Orden Compra</div>
                                            <div className="text-900 font-medium text-lg">{formatCurrency(data.dato?.saldoOrden) || '—'}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </Dialog>
    );
};

export default DatosDialog;